module.exports = __webpack_public_path__ + "static/img/screw_xy_platform.aaefe05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/screw_xy_platform.png
// module id = Jyav
// module chunks = 3